document.addEventListener('DOMContentLoaded', initVolumeOffers);
document.addEventListener('shopify:section:load', initVolumeOffers);

function initVolumeOffers() {
  document.querySelectorAll('.vl-box').forEach((box) => {
    if (box.dataset.initialized === 'true') return;
    box.dataset.initialized = 'true';

    const setQuantity = (qty) => {
      const scope =
        box.closest('.product__info-container') ||
        box.closest('.product__info-wrapper') ||
        box.closest('product-info') ||
        document;

      const qtyInput =
        scope.querySelector('input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]');

      if (!qtyInput) return;

      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    box.querySelectorAll('.vl-card').forEach((card) => {
      card.addEventListener('click', () => {
        box.querySelectorAll('.vl-card').forEach((c) => c.classList.remove('is-active'));
        card.classList.add('is-active');

        const qty = parseInt(card.dataset.qty, 10);
        if (qty) setQuantity(qty);
      });
    });

    const endTime = new Date(box.dataset.end).getTime();
    const dEl = box.querySelector('.vl-d');
    const hEl = box.querySelector('.vl-h');
    const mEl = box.querySelector('.vl-m');
    const sEl = box.querySelector('.vl-s');

    function updateTimer() {
      const diff = endTime - Date.now();

      if (diff <= 0) {
        dEl.textContent = '00';
        hEl.textContent = '00';
        mEl.textContent = '00';
        sEl.textContent = '00';
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      dEl.textContent = String(days).padStart(2, '0');
      hEl.textContent = String(hours).padStart(2, '0');
      mEl.textContent = String(mins).padStart(2, '0');
      sEl.textContent = String(secs).padStart(2, '0');
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
}